document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.el-header__menu-toggle');
  var mobileNav = document.getElementById('el-mobile-nav');

  if (!toggle || !mobileNav) return;

  toggle.addEventListener('click', function () {
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    mobileNav.hidden = isOpen;
  });

  // Close mobile nav when a link inside it is clicked
  mobileNav.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () {
      toggle.setAttribute('aria-expanded', 'false');
      mobileNav.hidden = true;
    });
  });
});
